import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  convertToHalfWidthNumbers(event) {
    const input = event.target;
    if (!input.value) return;
    input.value = input.value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
  }
}
